<template lang="html">
    <div>
        <div v-if="loading">
            <div style="text-align:center">
                <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <div v-if="loading == false">
            <div class="box">
                <div class="box-body" style="padding: 8px;">
                    <div class="row">
                        <div class="col-md-8">
                            <select2 name="Servisler"
                                     :data="services"
                                     :selected="filters.service"
                                     :maxSelection="5"
                                     :minSelection="1"
                                     v-on:onChange="onServiceFilterChanged" />
                        </div>
                        <div class="col-md-4">
                            <div class="float-lg-right">
                                <daterange :dateRange="filters.dateRange" v-on:onChange="onDateFilterChanged" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <autoupdate :loading="reportDataLoading" v-on:refreshData="loadData" />
            <div class="box">
                <div class="box-body">
                    <chart v-model="data" />
                </div>
            </div>
            <div class="box">
                <table2 v-model="data" />
            </div>
        </div>
    </div>
</template>

<script>
import parallel from 'async/parallel';
import Select2 from '../../../components/select.v2.vue';
import DateRange from '../../../components/daterange.vue';
import Chart from '../../../components/chart.vue';
import Table from '../../../components/table.vue';
import AutoUpdate from '../../../components/auto_update.vue';
import moment from 'moment';
import TimezoneChangeMixin from '../../../mixins/timezone-change.vue';

export default {
    mixins: [TimezoneChangeMixin],
    components: {
        'select2': Select2,
        'daterange': DateRange,
        'chart': Chart,
        'table2': Table,
        'autoupdate': AutoUpdate
    },
    data: function () {
        return {
            filters: {
                service: [],
                dateRange: [moment(), moment()]
            },
            services: [],
            data: {},
            loading: false,
            reportDataLoading: true
        };
    },
    mounted: function () {
        var $this = this;
        this.loading = true;
        parallel([
            function (next) {
                var params = {
                    dashboard_id: $this.$router.currentRoute.query.id
                };
                $this.$app.get('/api/v1/users/' + $this.$app.getUser().id + '/services', params, function(xhr) {
                    var response = xhr.responseJSON;
                    $this.services = $.map(response.services, function (service) {
                        return {
                            id: service.id,
                            text: service.name
                        }
                    });
                    $this.filters.service.push($this.services[0].id);
                    next();
                });
            }
        ], function (err, results) {
            $this.loading = false;
            $this.loadData();
        });
    },
    methods: {
        loadData: function () {
            this.reportDataLoading = true;
            var $this = this;
            var params = {
                id: this.$router.currentRoute.query.id,
                service_id: this.filters.service,
                start_date: this.filters.dateRange[0].format('YYYY-MM-DD'),
                end_date: this.filters.dateRange[1].format('YYYY-MM-DD')
            };
            this.$app.get('/api/v1/dashboards/report/subscription/total-data', params, function(xhr) {
                $this.reportDataLoading = false;
                var response = xhr.responseJSON;
                $this.data = response.data;
            }, {'Timezone': this.$app.getTimezone()});
        },
        onServiceFilterChanged: function (data) {
            this.filters.service = data;
            this.loadData();
        },
        onDateFilterChanged: function (data) {
            this.filters.dateRange = data;
            this.loadData();
        }
    }
}
</script>



// WEBPACK FOOTER //
// total.vue?6d745340